<template>
  <v-app id="inspire" v-if="signedIn && googleSignedIn">
    <v-navigation-drawer v-model="drawer" app left clipped>
      <div class="app-title">
        <img
          src="@/assets/logo.png"
          height="90%"
          width="90%"
          class="mx-2"
          style="padding: 3px;"
          alt="Mail Switch logo"
        />
      </div>

      <v-divider class="mt-2"></v-divider>

      <v-list dense>
        <v-subheader>Administer Mail Switch</v-subheader>
        <v-list-item
          link
          v-for="route in navRoutes"
          :key="route.name"
          :to="route.path"
        >
          <v-list-item-action>
            <v-icon>{{ route.meta.icon }}</v-icon>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>{{ route.meta.title }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app color="primary" dark clipped-left>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>

      <v-toolbar-title class="title">{{ $route.meta.title }}</v-toolbar-title>

      <v-layout row wrap justify-end class="pr-4">
        <v-flex shrink>
          <v-menu offset-y persistent>
            <template v-slot:activator="{ on }">
              <v-avatar size="48" v-on="on" color="primary darken-2"
                ><span style="pointer-events: none;">{{
                  name[0].toUpperCase()
                }}</span></v-avatar
              >
            </template>

            <v-list dense width="150">
              <v-list-item @click="gSignOut">
                <v-list-item-title v-text="'Logout'"></v-list-item-title>
                <v-list-item-icon><v-icon>mdi-logout</v-icon></v-list-item-icon>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
    </v-app-bar>

    <v-main>
      <v-progress-linear
        :indeterminate="loading"
        v-if="loading"
        color="primary lighten-1"
      ></v-progress-linear>

      <v-container class="container-custom">
        <router-view />
      </v-container>
    </v-main>

    <error-snackbar></error-snackbar>
  </v-app>
</template>
<style>
.container-custom {
  max-width: 80%;
}

.app-title {
  height: 60px;
  display: flex;
  align-items: center;
}
</style>

<style lang="scss">
@font-face {
  font-family: "Readex Pro";
  src: url("~@/assets/fonts/ReadexPro-Regular.ttf");
}

$body-font-family: "Readex Pro";
$title-font: "Readex Pro";

.v-application {
  font-family: $body-font-family, sans-serif !important;
  * {
    font-family: $title-font, sans-serif !important;
  }
  .headline {
    font-family: $title-font, sans-serif !important;
  }
  .display-2 {
    font-family: $title-font, sans-serif !important;
  }
}
</style>

<script>
import { routes } from "@/router/index.js";
import ErrorSnackbar from "@/components/ErrorSnackbar";

import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    ErrorSnackbar,
  },

  data: () => ({
    drawer: null,
    routes,
    title: process.env.VUE_APP_TITLE,
  }),

  computed: {
    ...mapGetters({
      appName: "appName",
      googleSignedIn: "google/signedIn",
      signedIn: "user/signedIn",
      loading: "loading",
      name: "google/name",
    }),

    navRoutes() {
      return this.routes.filter((v) => v.meta.nav);
    },
  },

  methods: {
    ...mapActions({
      signOut: "google/signOut",
      userSignOut: "user/userSignOut",
    }),

    async gSignOut() {
      await this.signOut();
      await this.userSignOut();
    },
  },

  watch: {
    async signedIn(v) {
      if (v) {
        try {
          await this.$store.dispatch("user/authenticate");
        } catch (e) {
          this.$store.dispatch("error/handle", e);
        }
      }
    },
  },
};
</script>
